import rdlLogo from "../../images/RDL.png";
import cilLogo from "../../images/CIL.png";
import nslLogo from "../../images/NSL.png";
import "./CSR.css";

export default function CSR() {
  return (
    <section className="sports-page">
      <div className="sports-inner">
        <h1 className="sports-title">Clarens Sportz Revive</h1>
        <p className="sports-sub">It is all about reviving sports in Clarens Community</p>
      </div>
      <div className="sports-columns">
        <div className="sports-column">
          <h2 className="sports-column-title">Netball</h2>
          <div className="sports-column-content">
            <div>
              <div className="sports-subtitle-row">
                <h3 className="sports-column-subtitle sports-subtitle-netstars">Clarens NetStars</h3>
                <img src={nslLogo} alt="Clarens NetStars" className="sports-team-logo" />
              </div>
              <p className="sports-column-text">Clarens NetStars is proud to open an U18 Netball team for young girls aged 18 and under. Those who are passionate about netball and not currently committed to a team are welcome to come for try outs. We are looking for dedication, team spirit, and a love for the game. For more info please contact Quattro Mokoena (068 216 2634).</p>
            </div>
            <div className="sports-column-info">
              <p><strong>Venue:</strong> <span>Kgubetswana Stadium</span></p>
              <p><strong>Time:</strong> <span>16h00 till late</span></p>
              <p><strong>Days:</strong> <span>Mon - Fri</span></p>
            </div>
          </div>
          <div className="sports-column-content">
            <div>
              <div className="sports-subtitle-row">
                <h3 className="sports-column-subtitle">Clarens Red Dragons</h3>
                <img src={rdlLogo} alt="Clarens Red Dragons" className="sports-team-logo" />
              </div>
              <p className="sports-column-text">Clarens Red Dragons is an U16 unisex Netball team open to both boys and girls under the age of 16. Those who are passionate about netball and not currently committed to a team are welcome to come for try outs. We are looking for dedication, team spirit, and a love for the game. For more info please contact Quattro Mokoena (068 216 2634).</p>
            </div>
            <div className="sports-column-info">
              <p><strong>Venue:</strong> <span>Kgubetswana Stadium</span></p>
              <p><strong>Time:</strong> <span>15h00 - 16h00</span></p>
              <p><strong>Days:</strong> <span>Mon - Fri</span></p>
            </div>
          </div>
        </div>
        <div className="sports-column">
          <h2 className="sports-column-title">Volleyball</h2>
          <div className="sports-column-content">
            <div>
              <div className="sports-subtitle-row">
                <h3 className="sports-column-subtitle sports-subtitle-impact">Clarens Impact</h3>
                <img src={cilLogo} alt="Clarens Impact" className="sports-team-logo" />
              </div>
              <p className="sports-column-text">Clarens Impact is an U18 and 18+ Men's Volleyball team open to young men aged 18 and above. Those who are passionate about volleyball and not currently committed to a team are welcome to come for try outs. We are looking for dedication, team spirit, and a love for the game. For more info please contact Quattro Mokoena (068 216 2634).</p>
            </div>
            <div className="sports-column-info">
              <p><strong>Venue:</strong> <span>Kgubetswana Stadium</span></p>
              <p><strong>Time:</strong> <span>17h00 - 18h30</span></p>
              <p><strong>Days:</strong> <span>Mon - Fri</span></p>
            </div>
          </div>
        </div>
        <div className="sports-column">
          <h2 className="sports-column-title">Football</h2>
          <p className="sports-column-text">Clarens Sportz Revive is willing to open a Football team for young boys from 16 years and above. Those who are willing and are not committed to a team can come for try outs. We are looking for passion for the game, self driven, those who are willing to fulfil their love of football. For your info please contact Quattro Mokoena (068 216 2634).</p>
        </div>
      </div>
    </section>
  );
}